// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// import echarts from 'echarts';
// Vue.prototype.$echarts = echarts;


// 文件引用
import '@/assets/js/public'

import {globalConfig} from "../config/global";

Vue.prototype.globalConfig = globalConfig;


Vue.config.productionTip = false

Vue.directive('title', {
  inserted: (el, binding) => {
    document.title = binding.value;
  },
  update: (el, binding) => {
    document.title = binding.value;
  }
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js